import React, { Component } from "react";
import Select from "../common/Select";
import Input from "../common/Input";
import CheckBox from "../common/Check-box";
import Toggle from "../common/Toggle-button";
import { Redirect } from "react-router-dom";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import API from "../common/Api";
import moment from 'moment';

const mapStateToProps = (state) => ({
  percentageCut: state.percentageCut,
  headers: state.headers(),
  bookingSettings: state.bookingSettings,
  business: state.business,
});

export default connect(mapStateToProps)(
  class BookingSettings extends Component {
    state = {
      showTeamMembers: this.props.bookingSettings.show_team_members,
      allowBookingNotes: this.props.bookingSettings.allow_booking_notes,
      priorityBooking: this.props.bookingSettings.priority_booking,
      allowAddress: this.props.bookingSettings.allow_address,
      hideAddress: this.props.bookingSettings.hide_business_address,
      hideClientContactDetails:
        this.props.bookingSettings.hide_client_contact_details_from_employees,
      sameDayBooking: this.props.bookingSettings.same_day_booking,
      sameDayBookingTime: this.props.bookingSettings.same_day_booking_time,
      receivePayments: this.props.bookingSettings.receive_payment,
      checkedDays: this.props.bookingSettings.priority_booking_days || [],
      customBookingSuccessMessage:
        this.props.bookingSettings.custom_booking_success_message,
      customBookingSuccessBtnText:
        this.props.bookingSettings.custom_booking_success_btn_text,
      customBookingSuccessBtnLink:
        this.props.bookingSettings.custom_booking_success_btn_link,
      loading: false,
      bookingSettings: {},
      loaded: true,
      customMessageErrors: {},

      // --- Referral Code State ---
      referralCodeInput: "",
      appliedReferralCode: "",
      isReferralCodeActive: false,
      isApplyingReferral: false,
      expiresAt: '',
    };

    priorityBooking = (bool) => {
      this.setState({ priorityBooking: bool });
    };

    showTeamMembers = (bool) => {
      this.setState({ showTeamMembers: bool });
    };
    allowBookingNotes = (bool) => {
      this.setState({ allowBookingNotes: bool });
    };
    receivePayments = (bool) => {
      this.setState({ receivePayments: bool });
    };
    allowAddress = (bool) => {
      this.setState({ allowAddress: bool });
    };

    toggleHideAddress = (bool) => {
      this.setState({ hideAddress: !bool });
    };

    togglehideClientContactDetails = (bool) => {
      this.setState({
        hideClientContactDetails: bool,
      });
    };
    days = [
      { name: "monday" },
      { name: "tuesday" },
      { name: "wednesday" },
      { name: "thursday" },
      { name: "friday" },
      { name: "saturday" },
      { name: "sunday" },
    ];

    isValidUrl = (value) => {
      if (!value || typeof value !== "string") return false;

      // Must start with protocol
      if (!/^https?:\/\//i.test(value)) return false;

      try {
        const url = new URL(value);
        const host = url.hostname;

        // Must contain a dot
        if (!host.includes(".")) return false;

        // Basic domain structure: something.something
        const domainRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
        return domainRegex.test(host);
      } catch {
        return false;
      }
    };

    // --- Referral Code Handlers ---
    getReferralCode = () => {
      API.get("business/referral-code", {
        headers: this.props.headers,
      })
        .then(({ data }) => {
          const code = data?.data?.code || data?.code;
          const expires_at = data?.data?.expires_at || data?.expires_at;

          if (code) {
            this.setState({
              appliedReferralCode: code,
              isReferralCodeActive: true,
              expiresAt: moment(expires_at).format('Do MMM, YYYY')
            });
          }
        })
        .catch((error) => {
          console.error("Failed to fetch active referral code:", error);
        });
    };

    applyReferralCode = async () => {
      const { referralCodeInput } = this.state;

      if (!referralCodeInput.trim()) {
        window.$.notify("Please enter a referral code to apply", "error-alert");
        return;
      }

      this.setState({ isApplyingReferral: true });

      try {
        const response = await API.post(
          "business/referral-code",
          { code: referralCodeInput },
          { headers: this.props.headers }
        );

        if (response.data.is_valid) {
          const expires_at = response?.data?.expires_at;
          this.setState({
            appliedReferralCode: referralCodeInput,
            isReferralCodeActive: true,
            referralCodeInput: "",
            expiresAt: moment(expires_at).format('Do MMM, YYYY')

          });
          window.$.notify(response.data.message, "success-alert");
        } else {
          window.$.notify("Referral code is invalid or expired", "error-alert");
          this.setState({ isReferralCodeActive: false, appliedReferralCode: "" });
        }
      } catch (error) {
        window.$.notify(
          error.response?.data?.message || "Failed to apply referral code",
          "error-alert"
        );
      } finally {
        this.setState({ isApplyingReferral: false });
      }
    };

    BookingSettings = (ev) => {
      ev.preventDefault();
      const {
        customBookingSuccessMessage,
        customBookingSuccessBtnText,
        customBookingSuccessBtnLink,
        appliedReferralCode,
      } = this.state;

      const errors = {};

      const allEmpty =
        !customBookingSuccessMessage &&
        !customBookingSuccessBtnText &&
        !customBookingSuccessBtnLink;

      const allFilled =
        customBookingSuccessMessage &&
        customBookingSuccessBtnText &&
        customBookingSuccessBtnLink;

      // --- Case 1: PARTIALLY FILLED → stop and show errors ---
      if (!allEmpty && !allFilled) {
        if (!customBookingSuccessMessage)
          errors.message = "Message is required";

        if (!customBookingSuccessBtnText)
          errors.buttonText = "Button Text is required";

        if (!customBookingSuccessBtnLink)
          errors.buttonLink = "Button Link is required";

        this.setState({ customMessageErrors: errors });
        return;
      }

      // --- Case 2: ALL FILLED → deeper validation ---
      if (allFilled) {
        if (customBookingSuccessBtnText.length > 12) {
          errors.buttonText = "Button Text must not exceed 12 characters";
        }

        if (!this.isValidUrl(customBookingSuccessBtnLink)) {
          errors.buttonLink =
            "Please enter a valid URL (e.g. https://example.com)";
        }

        if (Object.keys(errors).length > 0) {
          this.setState({ customMessageErrors: errors });
          return;
        }
      }

      this.setState({ customMessageErrors: {} });

      this.setState({ loading: true });
      const loaded = () => this.setState({ loading: false });
      const form = ev.currentTarget;
      const body = {
        handles_processing_fee: form.handles_processing_fee?.value,
        appointment_gap: form.appointment_gap?.value,
        upfront_percentage_payment: form.upfront_percentage_payment?.value,
        priority_booking: this.state.priorityBooking,
        show_team_members: this.state.showTeamMembers,
        allow_booking_notes: this.state.allowBookingNotes,
        allow_address: this.state.allowAddress,
        hide_business_address: this.state.hideAddress,
        hide_client_contact_details_from_employees:
          this.state.hideClientContactDetails,
        receive_payment: this.state.receivePayments,
        priority_booking_fee: form.priority_booking_fee?.value,
        cancellation_percentage_payment:
          form.cancellation_percentage_payment?.value,
        no_show_percentage_payment: form.no_show_percentage_payment?.value,
        priority_booking_days: this.state.checkedDays,
        same_day_booking: this.state.sameDayBooking,
        same_day_booking_time: form.same_day_booking_time?.value,

        custom_booking_success_message: customBookingSuccessMessage || null,
        custom_booking_success_btn_text: customBookingSuccessBtnText || null,
        custom_booking_success_btn_link: customBookingSuccessBtnLink || null,

        applied_referral_code: this.state.isReferralCodeActive ? appliedReferralCode : null,
      };

      API.put("business/booking-settings", body, {
        headers: this.props.headers,
      }).then(({ data }) => {
        loaded();
        this.props.dispatch({
          type: "GET_BOOKING_SETTINGS",
          data: data.data,
        });
        window.$.notify("Booking Settings Updated", "success-alert");
      });
    };

    getBookingSettings = () => {
      API.get("business/booking-settings", {
        headers: this.props.headers,
      }).then(({ data }) => {
        this.setState({
          bookingSettings: data.data,
          showTeamMembers: data.data.show_team_members,
          allowBookingNotes: data.data.allow_booking_notes,
          priorityBooking: data.data.priority_booking,
          allowAddress: data.data.allow_address,
          hideAddress: data.data.hide_business_address,
          hideClientContactDetails:
            data.data.hide_client_contact_details_from_employees,
          sameDayBooking: data.data.same_day_booking,
          sameDayBookingTime: data.data.same_day_booking_time,
          receivePayments: data.data.receive_payment,
          checkedDays: data.data.priority_booking_days || [],
          customBookingSuccessMessage: data.data.custom_booking_success_message,
          customBookingSuccessBtnText:
            data.data.custom_booking_success_btn_text,
          customBookingSuccessBtnLink:
            data.data.custom_booking_success_btn_link,
        });
        this.setState({ loading: false });
      });
    };

    componentDidMount = () => {
      this.getBookingSettings();
      this.getReferralCode(); // Fetch active referral code on mount
    };

    percentageCutOptions = (name) =>
      this.props.percentageCut.map((cut) => (
        <option
          key={cut}
          value={cut}
          selected={Number(this.state.bookingSettings[name]) === cut}
        >
          {cut}%
        </option>
      ));

    render() {
      return (
        <>
          {this.state.bookingSettings.id ? (
            <div className="onboarding-page businessSetting">
              <h1 className="form-title dsk">Booking settings</h1>
              <div className="form_step form-page">
                <h1 className="form-title mbl flex center">
                  <BackArrow />
                  Booking settings
                </h1>
                <div className="form-container card restrict">
                  <form onSubmit={this.BookingSettings}>
                    {this.state.bookingSettings.receive_payment === true ? (
                      <>
                        <Select
                          className="input-rapper withmini"
                          label="What percentage of payment do you require?"
                          placeholder="Select %"
                          name="upfront_percentage_payment"
                          value={this.state.bookingSettings.upfront_percentage_payment ?? 100}
                          onChange={(e) => this.setState({
                            bookingSettings: {
                              ...this.state.bookingSettings,
                              upfront_percentage_payment: Number(e.target.value)
                            }
                          })}
                          required
                        >
                          {this.props.percentageCut.map((cut) => (
                            <option key={cut} value={cut}>
                              {cut}%
                            </option>
                          ))}
                        </Select>
                        <div
                          className="input_highlight"
                          style={{ marginTop: "-30px" }}
                        >
                          <small>
                            Set this to <b>100%</b> if you plan to use discount
                            codes
                          </small>
                        </div>

                        <div>
                          <Select
                            label="Who should be charged the processing fee?"
                            placeholder="Select an option"
                            name="handles_processing_fee"
                            required
                          >
                            <option
                              value="customer"
                              selected={
                                this.state.bookingSettings[
                                "handles_processing_fee"
                                ] === "customer"
                              }
                            >
                              Customer
                            </option>

                            <option
                              value="business"
                              selected={
                                this.state.bookingSettings[
                                "handles_processing_fee"
                                ] === "business"
                              }
                            >
                              My Business
                            </option>
                          </Select>

                          {/* --- REFERRAL CODE SECTION START --- */}
                          <div style={{ marginTop: "20px" }}>
                            {this.state.isReferralCodeActive && this.state.appliedReferralCode ? (
                              <div className="applied-code-state">
                                <Input
                                  label="Referral Code"
                                  name="applied_referral_code"
                                  value={this.state.appliedReferralCode}
                                  readOnly
                                  disabled
                                  className="input-rapper"
                                />
                                <small style={{ color: "green", marginTop: "-20px", marginBottom: "30px", display: "block" }}>
                                  ✓ Active and will expire on {this.state.expiresAt}
                                </small>
                              </div>
                            ) : (
                              <div className="referral-input-container flex" style={{ gap: "15px", alignItems: "flex-start" }}>
                                <div style={{ flexGrow: 1 }}>
                                  <Input
                                    label="Referral Code"
                                    name="referral_code_input"
                                    placeholder="Enter referral code"
                                    value={this.state.referralCodeInput}
                                    onChange={(e) =>
                                      this.setState({ referralCodeInput: e.target.value })
                                    }
                                    className="input-rapper"
                                  />
                                </div>
                                <button
                                  type="button"
                                  className={`default ${this.state.isApplyingReferral ? "loading" : ""
                                    }`}
                                  onClick={this.applyReferralCode}
                                  style={{ marginTop: "25px", padding: "14px 20px" }}
                                >
                                  Apply
                                </button>
                              </div>
                            )}
                          </div>
                          {/* --- REFERRAL CODE SECTION END --- */}

                          <Select
                            label="Booking buffer"
                            placeholder="Set time between bookings"
                            name="appointment_gap"
                            required
                          >
                            <option
                              value="0"
                              selected={
                                this.state.bookingSettings["appointment_gap"] === 0
                              }
                            >
                              No Buffer
                            </option>
                            <option
                              value="30"
                              selected={
                                this.state.bookingSettings["appointment_gap"] === 30
                              }
                            >
                              30 minutes
                            </option>
                            <option
                              value="60"
                              selected={
                                this.state.bookingSettings["appointment_gap"] === 60
                              }
                            >
                              1 hour
                            </option>
                          </Select>

                          <>
                            <div className="header flex space-btw form-section-heading">
                              <p style={{ marginRight: "17px" }} className="title">
                                Turn on Same day Booking
                              </p>
                              <Toggle
                                data_open={
                                  this.state.sameDayBooking ? true : false
                                }
                                OnChange={(can_book_same_day) => {
                                  this.setState({
                                    sameDayBooking: can_book_same_day,
                                  });
                                }}
                              />
                            </div>

                            {this.state.sameDayBooking ? (
                              <div>
                                <Select
                                  label="What time gap do you require before a same-day booking?"
                                  placeholder="Select an option"
                                  name="same_day_booking_time"
                                  required
                                >
                                  <option selected={this.state.sameDayBookingTime === 900} value="900">15 min</option>
                                  <option selected={this.state.sameDayBookingTime === 1800} value="1800">30 min</option>
                                  <option selected={this.state.sameDayBookingTime === 3600} value="3600">1 hour</option>
                                  <option selected={this.state.sameDayBookingTime === 7200} value="7200">2 hours</option>
                                  <option selected={this.state.sameDayBookingTime === 10800} value="10800">3 hours</option>
                                  <option selected={this.state.sameDayBookingTime === 14400} value="14400">4 hours</option>
                                </Select>
                              </div>
                            ) : (
                              ""
                            )}

                            <div className="header flex space-btw form-section-heading">
                              <p style={{ marginRight: "17px" }} className="title">
                                Turn on priority booking
                              </p>
                              <Toggle
                                data_open={this.state.priorityBooking}
                                OnChange={this.priorityBooking}
                              />
                            </div>

                            {this.state.priorityBooking ? (
                              <div>
                                <Input
                                  label="set priority booking fee"
                                  type="number"
                                  name="priority_booking_fee"
                                  defaultValue={
                                    this.state.bookingSettings.priority_booking_fee
                                  }
                                  placeholder="Enter fee here"
                                  required
                                />
                              </div>
                            ) : (
                              ""
                            )}

                            <div className="header flex space-btw form-section-heading">
                              <p style={{ marginRight: "17px" }} className="title">
                                Show team members on booking page
                              </p>
                              <Toggle
                                data_open={this.state.showTeamMembers}
                                OnChange={this.showTeamMembers}
                              />
                            </div>

                            <div className="header flex space-btw form-section-heading">
                              <p style={{ marginRight: "17px" }} className="title">
                                Allow customer add booking notes
                              </p>
                              <Toggle
                                data_open={this.state.allowBookingNotes}
                                OnChange={this.allowBookingNotes}
                              />
                            </div>

                            <div className="header flex space-btw form-section-heading">
                              <p style={{ marginRight: "17px" }} className="title">
                                Require customer address?
                              </p>
                              <Toggle
                                data_open={this.state.allowAddress}
                                OnChange={this.allowAddress}
                              />
                            </div>

                            {this.props.business.location_type === "Physical Location" && (
                              <div className="header flex space-btw form-section-heading">
                                <p style={{ marginRight: "17px" }} className="title">
                                  Display address on booking page?
                                </p>
                                <Toggle
                                  data_open={!this.state.hideAddress}
                                  OnChange={this.toggleHideAddress}
                                />
                              </div>
                            )}

                            <div className="header flex space-btw form-section-heading">
                              <p style={{ marginRight: "17px" }} className="title">
                                Hide client contact details from staff?
                              </p>
                              <Toggle
                                data_open={this.state.hideClientContactDetails}
                                OnChange={this.togglehideClientContactDetails}
                              />
                            </div>

                            {process.env.NODE_ENV !== "production" ? (
                              <div
                                style={{
                                  height: "fit-content",
                                  width: "100%",
                                  marginTop: "32px",
                                  marginBottom: "16px",
                                }}
                                className="form-section-container"
                              >
                                <p className="custom-section-header">
                                  Enter custom booking success message information
                                </p>

                                <Input
                                  label="Button Text"
                                  name="custom_button_text"
                                  placeholder="Button Text"
                                  type="text"
                                  required
                                  value={this.state?.customBookingSuccessBtnText ?? ""}
                                  onChangeAction={(value) =>
                                    this.setState({
                                      customBookingSuccessBtnText: value,
                                    })
                                  }
                                  className="input-rapper"
                                  error={this.state.customMessageErrors.buttonText}
                                />
                                <Input
                                  label="Button Link"
                                  name="custom_button_link"
                                  placeholder="Button Link"
                                  type="link"
                                  required
                                  value={this.state?.customBookingSuccessBtnLink ?? ""}
                                  onChangeAction={(value) =>
                                    this.setState({
                                      customBookingSuccessBtnLink: value,
                                    })
                                  }
                                  className="input-rapper"
                                  error={this.state.customMessageErrors.buttonLink}
                                />
                                <Input
                                  labelText="Message"
                                  type="text"
                                  name="custom_message"
                                  placeholder="Custom message"
                                  onChange={(e) =>
                                    this.setState({
                                      customBookingSuccessMessage: e.target.value,
                                    })
                                  }
                                  value={this.state?.customBookingSuccessMessage ?? ""}
                                  error={this.state.customMessageErrors.message}
                                  isTextarea
                                  rows={7}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        </div>
                      </>
                    ) : (
                      <p className="off text-center">Loading...</p>
                    )}

                    <span />

                    <div className="flex center space-btw">
                      <button
                        className={`default ${this.state.loading ? "loading" : ""}`}
                      >
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          ) : this.state.bookingSettings.success === true ? (
            <Redirect to="/onboarding/booking/settings/0" />
          ) : this.state.bookingSettings.success === false &&
            this.props.business === false ? (
            <Redirect to="/onboarding" />
          ) : (
            ""
          )}
        </>
      );
    }
  }
);